import { Settings } from "../Settings";

export const StoreOpenTimeAttrDayMapping:{[key:number]:string} = {
    1:"opentimemon",
    2:"opentimetue",
    3:"opentimewed",
    4:"opentimethu",
    5:"opentimefri",
    6:"opentimesat",
    7:"opentimesun",
}

export const DayNumberMapping:{[key:number]:string} = {
    1:"Maandag",
    2:"Dinsdag",
    3:"Woensdag",
    4:"Donderdag",
    5:"Vrijdag",
    6:"Zaterdag",
    7:"Zondag",
}

export const DaysNumberInAWeek =  [1,2,3,4,5,6,7];

export const HOME_DELIVERY = "shopOnline";
export const CLICK_AND_COLLECT = "pickUp";

export const CCStoreSearchAutoCompleteOptions = (settings:Settings) => ({
    radius:settings.userData.StoreLocator_Radius,
    radiusUOM:settings.userData.StoreLocator_RadiusUOM,
    maxItems:'25',
})